// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({
    adSection: window.AD_SECTION,
  });
  adLoader.init();
});

// Write your code!
import 'intersection-observer';
import mapboxgl from 'mapbox-gl';
import { Popup } from 'mapbox-gl';
import { intcomma } from 'journalize';
import { renderSvelteComponent } from './utils/render.js';
import { csv, json } from 'd3-fetch';
import { autoType } from 'd3-dsv';
import { getBounds } from './utils/bounds.js';
import { getPolyline } from './utils/polyline.js';

import {
  selNbh,
  precinctBassPct,
  precinctCarusoPct,
  isMobile,
} from './store.js';

//components
import Legend from './components/Legend.svelte';
import Details from './components/Details.svelte';
import Demographics from './components/Demographics.svelte';
import Nbhdescription from './components/Nbhdescription.svelte';

let precinctId = '';
const detailsContainer = document.getElementById('details-container');
const errorBox = document.getElementById('error-box');

const resize = () => {
  isMobile.set(window.innerWidth < 630 ? true : false);
  if (precinctId !== '') {
    updateSelBarLabelPosition();
  }
};

window.addEventListener('resize', resize);
resize();

const updateSelBarLabelPosition = () => {
  const allBars = document
    .querySelectorAll('.temp-container')[0]
    .querySelectorAll('.temp-bar');
  const lastBarIdx = allBars.length - 1;
  const temBarContainerEdge = allBars[lastBarIdx].getBoundingClientRect().left;
  const selNbhLabels = document.querySelectorAll('.demo-neighborhood-label');

  const thresh = 150;

  selNbhLabels.forEach((l, idx) => {
    if (temBarContainerEdge - l.getBoundingClientRect().left < thresh) {
      l.style.textAlign = 'right';
      l.querySelectorAll('div').forEach((el) => {
        el.style.transform =
          idx === 0 ? `translateX(-110%)` : `translateX(-132%)`;
      });
    }
  });
};

renderSvelteComponent(
  Legend,
  /** @type {HTMLElement} */
  (document.getElementById('legend-container'))
);

async function main() {
  const demoDataLoad = new URL(
    '../_data/nbh_mayor_elex_demo.csv',
    import.meta.url
  );
  const demoData = await csv(demoDataLoad, autoType);
  const nbhDataLoad = new URL(
    '../_data/nbh_mayor_elex_geo_merged.geojson',
    import.meta.url
  );
  const nbhData = await json(nbhDataLoad, autoType);

  const ccDataLoad = new URL(
    '../_data/ccd_mayor_elex_geo_merged.geojson',
    import.meta.url
  );
  const ccData = await json(ccDataLoad, autoType);

  mapboxgl.accessToken =
    'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

  const TILESET_ID = 'latimes.2022-precinct-mayor-results'; // From Tileset
  const SOURCE = '2022 precinct mayor results';
  const SOURCE_LAYER = '2022-precinct-mayor-resultsv'; // layer name

  renderSvelteComponent(
    Demographics,
    /** @type {HTMLElement} */
    (document.getElementById('demographics-container')),
    {
      data: demoData,
      // neighborhood: null,
    }
  );

  const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  const bounds = [
    [-120.7975, 32.2806], // Southwest coordinates
    [-112.8313, 35.37], // Northeast coordinates
  ];

  // map
  var map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/latimes/cla7n87e3000l15lhv9zhyehm', // From style page
    pitchWithRotate: false, // this prevents accidentially changing the pitch
    center: [-118.379, 34.036], // starting position [lng, lat]
    maxZoom: 14.5,
    minZoom: 7,
    zoom: 9,
    fitBoundsOptions: {
      padding: {
        top: 80,
        right: 80,
        bottom: 80,
        left: 80,
      },
    },
    maxBounds: bounds,
  });

  let hoveredStateId = null;
  let clickedStateId = null;

  map.on('load', () => {
    map.addSource(SOURCE, {
      type: 'vector',
      url: `mapbox://${TILESET_ID}`,
      promoteId: 'precinct',
    });

    map.on('mouseenter', SOURCE_LAYER, () => {
      map.getCanvas().style.cursor = 'pointer';
    });

    // // The feature-state dependent fill-opacity expression will render the hover effect
    // // when a feature's hover state is set to true.
    map.addLayer({
      'id': 'hover-opacity',
      'type': 'fill',
      'source': SOURCE,
      'source-layer': SOURCE_LAYER,
      'paint': {
        'fill-opacity': 0,
      },
    });

    map.addLayer({
      'id': 'hover-stroke',
      'type': 'line',
      'source': SOURCE,
      'source-layer': SOURCE_LAYER,
      'paint': {
        'line-color': '#333333',
        'line-width': 3,
        'line-opacity': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          1,
          0,
        ],
      },
    });

    function precinctHighlight(features) {
      errorBox.classList.add('hidden');

      if (clickedStateId) {
        map.setFeatureState(
          {
            source: SOURCE,
            sourceLayer: SOURCE_LAYER,
            id: clickedStateId,
          },
          {
            hover: false,
          }
        );
      }
      clickedStateId = features[0].id;
      hoveredStateId = features[0].id;

      var properties = features[0].properties;
      precinctId = properties.precinct;
      selNbh.set(properties.neighborhood);
      precinctBassPct.set(
        properties.bass_pct == undefined ? 0 : properties.bass_pct
      );
      precinctCarusoPct.set(
        properties.caruso_pct == undefined ? 0 : properties.caruso_pct
      );

      let ccDistrict = ccData.features.filter(function (ccd) {
        return ccd.properties.district == properties.district;
      });

      let neighborhood = nbhData.features.filter(function (nbh) {
        return nbh.properties.neighborhood == properties.neighborhood;
      });

      let neighborhoodFirst = nbhData.features.filter(function (nbh) {
        return nbh.properties.neighborhood == properties.first;
      });

      let neighborhoodSecond = nbhData.features.filter(function (nbh) {
        return nbh.properties.neighborhood == properties.second;
      });

      let precinctBounds = getBounds(features[0].geometry.coordinates);
      let precinctPolyline = getPolyline(features[0].geometry.coordinates);
      let ccDistrictBounds = getBounds(
        ccDistrict[0].geometry.coordinates,
        'district'
      );

      let neighborhoodBounds = getBounds(
        neighborhood[0].geometry.coordinates,
        'neighborhood'
      );

      let neighborhoodFirstBounds = getBounds(
        neighborhoodFirst[0].geometry.coordinates,
        'neighborhood'
      );

      let neighborhoodSecondBounds = getBounds(
        neighborhoodSecond[0].geometry.coordinates,
        'neighborhood'
      );

      map.fitBounds(precinctBounds, {
        padding: 40,
      });

      map.setFeatureState(
        {
          source: SOURCE,
          sourceLayer: SOURCE_LAYER,
          id: clickedStateId,
        },
        {
          hover: true,
        }
      );

      renderSvelteComponent(
        Nbhdescription,
        /** @type {HTMLElement} */
        (document.getElementById('nbhdescription-container')),
        {
          data: demoData.filter(
            (d) => d.neighborhood == properties.neighborhood
          )[0],
        }
      );

      renderSvelteComponent(
        Details,
        /** @type {HTMLElement} */
        (document.getElementById('details-container')),
        {
          precinct: precinctId,
          data: properties,
          mapboxToken: mapboxgl.accessToken,
          precinctPolyline: precinctPolyline,
          precinctBounds:
            '[' +
            precinctBounds._sw.lng +
            ',' +
            precinctBounds._sw.lat +
            ',' +
            precinctBounds._ne.lng +
            ',' +
            precinctBounds._ne.lat +
            ']',
          ccDistrictBounds:
            '[' +
            ccDistrictBounds._sw.lng +
            ',' +
            ccDistrictBounds._sw.lat +
            ',' +
            ccDistrictBounds._ne.lng +
            ',' +
            ccDistrictBounds._ne.lat +
            ']',
          neighborhoodBounds:
            '[' +
            neighborhoodBounds._sw.lng +
            ',' +
            neighborhoodBounds._sw.lat +
            ',' +
            neighborhoodBounds._ne.lng +
            ',' +
            neighborhoodBounds._ne.lat +
            ']',
          neighborhoodFirstBounds:
            '[' +
            neighborhoodFirstBounds._sw.lng +
            ',' +
            neighborhoodFirstBounds._sw.lat +
            ',' +
            neighborhoodFirstBounds._ne.lng +
            ',' +
            neighborhoodFirstBounds._ne.lat +
            ']',
          neighborhoodSecondBounds:
            '[' +
            neighborhoodSecondBounds._sw.lng +
            ',' +
            neighborhoodSecondBounds._sw.lat +
            ',' +
            neighborhoodSecondBounds._ne.lng +
            ',' +
            neighborhoodSecondBounds._ne.lat +
            ']',
        }
      );

      // move bar label text to the other side if bars located the right side of the chart are selected
      updateSelBarLabelPosition();
    }

    map.on('click', 'hover-opacity', (e) => {
      geocoder.clear();
      document
        .getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0]
        .blur();
      precinctHighlight(e.features);
    });

    map.on('mousemove', 'hover-opacity', function (e) {
      if (e.features.length > 0) {
        if (hoveredStateId != clickedStateId) {
          map.setFeatureState(
            {
              source: SOURCE,
              sourceLayer: SOURCE_LAYER,
              id: hoveredStateId,
            },
            {
              hover: false,
            }
          );
        }

        hoveredStateId = e.features[0].id;
        map.setFeatureState(
          {
            source: SOURCE,
            sourceLayer: SOURCE_LAYER,
            id: hoveredStateId,
          },
          {
            hover: true,
          }
        );

        popup
          .setLngLat(e.lngLat)
          .setHTML(renderTooltip(map.queryRenderedFeatures(e.point)[0]))
          .addTo(map);
      }
    });

    const popup = new Popup({
      closeButton: false,
      closeOnClick: false,
      offset: 8,
    });

    map.on('mouseleave', 'hover-opacity', function () {
      popup.remove();
    });

    function renderTooltip(props) {
      if (process.env.NODE_ENV === 'development') {
      }

      return `<div class="tooltip">
    ${
      (props.properties.total_votes == 0) |
      (props.properties.total_votes == undefined)
        ? `<div class="no-data">Votes have not yet been recorded in this area.*</div>`
        : `
        <p class="tooltip-title">Precinct ${props.properties.precinct}</p>
        <table class="tooltip-table">
          <thead>
            <tr>
              <th scope="col" class="text-left">Candidates</th>
              <th scope="col" class="text-right">Votes</th>
              <th scope="col" class="text-right">Pct.</th>
            </tr>
          </thead>
          <tbody>
            <tr class="winner">
              <th scope="row" class="text-left winner">${
                props.properties.winner == 'bass' ? 'Karen Bass' : 'Rick Caruso'
              }</th>
              <td class="text-right">${intcomma(
                props.properties.winner == 'bass'
                  ? props.properties.bass_votes
                  : props.properties.caruso_votes
              )}</td>
              <td class="text-right pct">${
                props.properties.winner == 'bass'
                  ? props.properties.bass_pct
                  : props.properties.caruso_pct
              }%</td>
            </tr>
            <tr>
              <th scope="row" class="text-left">${
                props.properties.winner == 'bass' ? 'Rick Caruso' : 'Karen Bass'
              }</th>
              <td class="text-right">${intcomma(
                props.properties.winner == 'bass'
                  ? props.properties.caruso_votes
                  : props.properties.bass_votes
              )}</td>
              <td class="text-right pct">${
                props.properties.winner == 'bass'
                  ? props.properties.caruso_pct
                  : props.properties.bass_pct
              }%</td>
            </tr>
          </tbody>
        </table><p class="total-votes">${intcomma(
          props.properties.total_votes
        )} total ${props.properties.total_votes == 1 ? 'vote' : 'votes'}</p>`
    }
      </div>`;
    }

    map.on('mouseleave', 'hover-opacity', function () {
      if (hoveredStateId != clickedStateId) {
        map.setFeatureState(
          {
            source: SOURCE,
            sourceLayer: SOURCE_LAYER,
            id: hoveredStateId,
          },
          {
            hover: false,
          }
        );
      }
      hoveredStateId = null;
    });

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      countries: 'us',
      region: 'ca',
      placeholder: 'Enter an address to find a precinct',
      bbox: [-121.543, 31.703, -112.919, 35.414],
      mapboxgl: mapboxgl,
    });

    map.addControl(
      new mapboxgl.NavigationControl({
        showCompass: false,
      }),
      'top-left'
    );

    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

    geocoder.on('result', function (e) {
      map.once('moveend', function () {
        fetchFeature(e.result).then((response) => {
          console.log(response);

          // Not in Los Angeles City and not in shapefile
          if ((response == undefined) | (response.length == 0)) {
            console.log('response undefined');
            detailsContainer.innerHTML = '';
            errorBox.classList.remove('hidden');
          } else if (response[0].CITY_NAME == 'Los Angeles') {
            // In Los Angeles City and has response

            console.log('response LA');
            var geocoder_point = map.project(e.result.center);
            var features = map.queryRenderedFeatures(geocoder_point);
            console.log(features);
            precinctHighlight(features);
            popup
              .setLngLat(e.result.center)
              .setHTML(renderTooltip(features[0]))
              .addTo(map);
          } else {
            // Not in Los Angeles City

            console.log('response not LA');
            detailsContainer.innerHTML = '';
            errorBox.classList.remove('hidden');
          }
        });
      });
    });
  });

  async function fetchFeature(g) {
    const CITY_TILESET_ID = 'latimes.8yhqtii4';
    const MapboxToken =
      'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';
    let coord = g.center;
    let tileApi = `https://api.mapbox.com/v4/${CITY_TILESET_ID}/tilequery/${coord[0]},${coord[1]}.json?&limit=8&access_token=${MapboxToken}`;

    let tileFeed = await json(tileApi);
    let features = tileFeed.features.map((d) => d.properties);
    return features;
  }
}

main();
